import { useQuery } from '@tanstack/react-query';
import { InfrastructureProjectsApi } from 'osep-generator-service-client-v1';
import { IAS_PROJECT_USED_UNIQUE_VALUES_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useInfraProjectUsedUniqueValues(projectId: string, enabled: boolean) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const cli = useQuery({
    queryKey: [IAS_PROJECT_USED_UNIQUE_VALUES_QUERY_KEY, projectId],
    queryFn: async () => {
      const config = await getApiConfig();
      const infraApi = new InfrastructureProjectsApi(
        config,
        undefined,
        axiosInstance,
      );
      const result = (
        await infraApi.getInfrastructureProjectUsedUniqueValues(projectId)
      ).data;

      return result;
    },
    enabled,
  });
  return cli;
}

export default useInfraProjectUsedUniqueValues;
